module.exports = __webpack_public_path__ + "static/media/6.7a55565a.jpg";